import { useState, useRef, useMemo } from "react";
import DataTableWrapper from '../../Utility/DataTableWrapper/DataTableWrapper';
import moment from 'moment';
import { EventoService } from "../../../services/EventoService";
import Modal from '../../Utility/Modal/Modal';

export default function DatiUtenteAudit(props) {
    const nazioni = props.nazioni;
    const comuni = props.comuni;
    const eventoService = new EventoService();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [title, setTitle] = useState("Dettaglio evento");
    const [content, setContent] = useState();
    const dtRef = useRef();

    const mapColumn = {
      'id': 'Id oggetto',
      'nome': 'Nome',
      'cognome': 'Cognome',
      'pec': 'PEC',
      'email': 'Email',
      'cittadinanza': 'Cittadinanza',
      'codiceFiscale': 'Codice fiscale',
      'capDomicilio': 'CAP (Domicilio)',
      'capResidenza': 'CAP (Residenza)',
      'viaDomicilio': 'Via (Domicilio)',
      'viaResidenza': 'Via (Residenza)',
      'civicoDomicilio': 'Civico (Domicilio)',
      'civicoResidenza': 'Civico (Residenza)',
      'comuneResidenza':'Comune (Residenza)',
      'comuneDomicilio':'Comune (Domicilio)',
      'statoDomicilio':'Stato (Domicilio)',
      'statoResidenza':'Stato (Residenza)',
      'domicilioComeResidenza': 'Domicilio come residenza',
      'prefisso': 'Prefisso',
      'telefono': 'Telefono',
      'createdAt': 'Data di creazione',
      'authorities': 'Ruoli',
      'operatori': 'Operatori',
      'presaVisione': 'Presa visione',
      'referenze': 'Referenze'
    }

    const openModal = (row) => {
      setTitle(`Dettaglio evento di ${row.azione}`);
      const columns = Object.keys(row.oggetto)
            .filter(el => ![
                "createdBy",
                "lastModifiedBy",
                "lastModifiedDate",
                "datiUtente"
              ].includes(el));
      let content = (
        <ul>
          {columns.map((el, index) => (
            <>
              {["comune", "comuneResidenza", "comuneDomicilio"].includes(el)? 
                <li
                  key={'provincia_'+index}
                  className={row.azione === 'SALVATAGGIO_DATI_UTENTE'
                    ? "rtds-border-b rtds-pb-1 rtds-border-gray-02"
                    : "rtds-mb-2 rtds-border-b rtds-pb-1 rtds-border-gray-02"}
                >
                  <strong>
                    Provincia{" "}
                    {el.includes("Residenza") ? "(Residenza)" : el.includes("Domicilio") ? "(Domicilio)" : ""}
                  </strong>: {writeValue(row.oggetto[el], "provincia", row)}
                </li> : null
              }
              <li
                key={el + "_" + index}
                className={row.azione === 'SALVATAGGIO_DATI_UTENTE'
                  ? "rtds-border-b rtds-pb-1 rtds-border-gray-02"
                  : "rtds-mb-2 rtds-border-b rtds-pb-1 rtds-border-gray-02"}
              >
                <strong>{mapColumn[el]}</strong>: {writeValue(row.oggetto[el], el, row)}
              </li>
            </>
          ))}
        </ul>
      );
      setContent(content);
      setIsModalOpen(true);
    }

    const writeValue = (data, el, row) => {
      switch(el) {
        case "authorities":
          return data.map((el, index) => `${el}${index !== data.length - 1? ', ': ''}`);
        case "domicilioComeResidenza":
        case "presaVisione":
          return data? "SI": "NO";
        case "statoResidenza":
        case "statoDomicilio":
          return nazioni.find(nazione => nazione.id === data?.id)?.nome;
        case "comuneDomicilio":
        case "comuneResidenza":
            return comuni?.[data]?.denominazione;
        case "createdAt":
          return moment(row.createdAt).format("DD/MM/YYYY HH:mm:ss");
        case "referenze":
          return data.map(el => el.codice + ' - ' + el.denominazione).join(',');
        case "operatori":
          return data.map(el => el.codice + ' - ' + el.denominazione).join(',');
        case "provincia":
          return comuni?.[data]?.denominazione_provincia;
        default:
          return data;
      }
    }

    const dtOptions = useMemo(() => {
        return {
          columns: [
            {
              name: "Id",
              data: "id",
              visible: true,
              sortable: false,
              searchable: false,
            },
            {
              name: "Azione",
              data: "azione",
              visible: true,
              sortable: false,
              searchable: true
            },
            {
              name: "C.F Utente",
              data: "codiceFiscale",
              visible: true,
              sortable: true,
              searchable: true
            },
            {
              name: "Data evento",
              data: "createdAt",
              visible: true,
              sortable: true,
              searchable: true,
              cell: (row, col) => {
                return moment(row.createdAt).format("DD/MM/YYYY HH:mm:ss");
              }
            },
            {
              name: "Dettaglio",
              data: "",
              visible: true,
              sortable: false,
              searchable: false,
              cell: (row, col) => (
                <div>
                  <button
                    type="button"
                    className="rtds-btn rtds-btn--secondary"
                    onClick={() => {openModal(row)}}
                    title="Visualizza"
                  >
                    Dettaglio
                    <svg
                        className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                    >
                        <use
                            xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--eye`}
                        />
                    </svg>
                  </button>
                </div>
              )
            }
          ],
          serverSide: true,
          rows: [],
          sorts: [{name:'createdAt',direction:'desc'}],
          hideSearch: false,
          title: "Elenco eventi Dati Utente",
          ajax: eventoService.getAllDt,
          ajaxParams: {
            entity: ['DatiUtente', 'Utente']
          }
        };
    }, []);

    return(
      <>
        <DataTableWrapper
            ref={dtRef}
            dtOptions={dtOptions}
        />

        <Modal
            isOpen={isModalOpen}
            title={title}
            onClose={() => setIsModalOpen(false)}
            hideActionButton={true}
            closeLabel='Chiudi'
            content={content}
        />
      </>
    )
}